export function collapse() {
  const acc = document.querySelectorAll('[data-toggle="collapse"]');
  let active = null;

  acc.forEach((item) => {
    item.style.cursor = 'pointer';

    item.addEventListener('click', () => {
      const panel = this.nextElementSibling;
      panel.classList.toggle('open');

      if (active) {
        active.style.maxHeight = null;
      }

      if (panel !== active) {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        active = panel;
      } else {
        active = null;
      }
    });
  });
}
